import i18n from "src/middleware/i18n";
//change DEV to PROD for prod api for user auth
const BASE_API = process.env.REACT_APP_BASE_URL;
import Cookies from 'js-cookie';

export const payment = async (paymentData) => {
  try {
    const accessToken = Cookies.get("access_token");
    if (!accessToken) {
      console.error("Access token is missing");
      return { success: false, message: "Access token is missing" };
    }

    const response = await fetch(`${BASE_API}/cart/payment`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: accessToken,
        "Content-Type": "application/json",
        "Content-Language": i18n.language,
      },
      body: JSON.stringify(paymentData),
    });

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`);
      error.status = response.status;
      throw error;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const { message } = await response.json();
      if (response.ok) {
        return { success: true, message };
      } else {
        return { success: false, message };
      }
    } else {
      console.error("Response is not JSON:", await response.text());
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("Error making payment:", error);
    throw error;
  }
};

export const remove_item = async (item_gid) => {
  try {
    const accessToken = Cookies.get("access_token");
    if (!accessToken) {
      console.error("Access token is missing");
      return { success: false, message: "Access token is missing" };
    }

    const response = await fetch(
      `${BASE_API}/cart/remove_item?gid=${item_gid}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`);
      error.status = response.status;
      throw error;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const { message } = await response.json();
      if (response.ok) {
        return { success: true, message };
      } else {
        return { success: false, message };
      }
    } else {
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("Error removing item:", error);
    throw error;
  }
};

export const add_item = async (item_gid) => {
  try {
    const accessToken = Cookies.get("access_token");
    if (!accessToken) {
      console.error("Access token is missing");
      return { success: false, message: "Access token is missing" };
    }

    const response = await fetch(`${BASE_API}/cart/add_item`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        item_gid: item_gid,
        quantity: 1,
      }),
    });

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`);
      error.status = response.status;
      throw error;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const { message } = await response.json();
      if (response.ok) {
        return { success: true, message };
      } else {
        return { success: false, message };
      }
    } else {
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("Error adding item:", error);
    throw error;
  }
};

export const cart = async () => {
  try {
    const accessToken = Cookies.get("access_token");
    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(`${BASE_API}/cart`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: accessToken,
      },
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.message || `HTTP error! Status: ${response.status}`);
      error.status = response.status;
      throw error;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const data = await response.json();
      return data;
    } else {
      const text = await response.text();
      console.error("Response is not JSON:", text);
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
    // Re-throw the error to preserve status code for upstream handlers
    throw error;
  }
};

